import * as ConfigActions from '../actions/config';
import { Config } from '../../services/config/models/config';
import { XenaGlobalConfig } from '../../services/config/models/xena-global-config';
import { UraniaConfig } from '../../services/config/models/urania-config';
import { NeoConfig } from '../../services/config/models/neo-config';


export const CONFIG_SCOPE_XENA: string = 'xena';
export const CONFIG_SCOPE_XENA_GLOBAL: string = 'xenaGlobal';
export const CONFIG_SCOPE_URANIA: string = 'urania';
export const CONFIG_SCOPE_NEO: string = 'neo';

export interface StateObject {
	scope: string;
	config: any;
	tempConfig: any; // save temporary changes before write to db
	revision: string;
}

export type State = Array<StateObject>;

export const InitialState: State = [
	{ scope: CONFIG_SCOPE_XENA, config: null, tempConfig: null, revision: null },
	{ scope: CONFIG_SCOPE_XENA_GLOBAL, config: null, tempConfig: null, revision: null },
	{ scope: CONFIG_SCOPE_URANIA, config: null, tempConfig: null, revision: null },
	{ scope: CONFIG_SCOPE_NEO, config: null, tempConfig: null, revision: null },
];



export function reducer(state: State = InitialState, action: ConfigActions.All): State {
	switch (action.type) {
		case ConfigActions.SET_TEMP_CONFIG_SUCCESS:
			return state.map(config => ({...config, ...(config.scope === action.scope ? { ...config, tempConfig: action.payload } : config)}));

		case ConfigActions.LOAD_CONFIG_SUCCESS:
		case ConfigActions.SAVE_CONFIG_SUCCESS:
		case ConfigActions.INIT_CONFIG_STATE:
			return state.map((configState: StateObject) => {
				if (configState.scope === action.scope) {
					return {
						...configState,
						revision: action.revision,
						config: {
							...(action.type === ConfigActions.SAVE_CONFIG_SUCCESS && action.patch ? configState.config : {}),
							...action.payload
						},
						tempConfig: null
					};
				}

				return configState;
			});

		default:
			return state;
	}
}

export const GetTempConfig = (s: State): Config => s.find(state => state.scope === CONFIG_SCOPE_XENA).tempConfig;
export const GetNeoConfig = (s: State): NeoConfig => s.find(state => state.scope === CONFIG_SCOPE_NEO).config;
export const GetNeoConfigRev = (s: State): string => s.find(state => state.scope === CONFIG_SCOPE_NEO).revision;
export const GetUraniaConfig = (s: State): UraniaConfig => s.find(state => state.scope === CONFIG_SCOPE_URANIA).config;
export const GetUraniaConfigRev = (s: State): string => s.find(state => state.scope === CONFIG_SCOPE_URANIA).revision;
export const GetXenaConfig = (s: State): Config => s.find(state => state.scope === CONFIG_SCOPE_XENA).config;
export const GetXenaGlobalConfig = (s: State): XenaGlobalConfig => s.find(state => state.scope === CONFIG_SCOPE_XENA_GLOBAL).config;
export const GetXenaConfigRev = (s: State): string => s.find(state => state.scope === CONFIG_SCOPE_XENA).revision;
export const GetXenaGlobalConfigRev = (s: State): string => s.find(state => state.scope === CONFIG_SCOPE_XENA_GLOBAL).revision;
export const GetXenaComponents = (s: State): Array<string> => ['CRUISE'].concat(s.find(state => state.scope === CONFIG_SCOPE_XENA).config.components.filter(c => {
	const forceRoute = window.sessionStorage.getItem('force_route');

	if (forceRoute) {
		return c === forceRoute;
	}

	return true;
}));



// WEBPACK FOOTER //
// ./src/app/shared/state-management/reducers/config.ts